import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {TransactionRule} from "../../../models/transactionRule.interface";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatTooltip} from "@angular/material/tooltip";
import {NgIf} from "@angular/common";
import {TransactionsRulesService} from "../../../services/transactionsRules.service";
import {cloneDeep} from "lodash-es";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
    selector: 'fuse-confirmation-dialog',
    templateUrl: './duplicate-rule-dialog.component.html',
    styles: [
        `
            .fuse-confirmation-dialog-panel {

                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatButtonModule, MatDialogModule, MatIconModule, MatProgressSpinner, MatTooltip, NgIf],
})
export class DuplicateRuleDialogComponent implements OnInit {

    rule: TransactionRule;
    duplicating: boolean;

    /**
     * Constructor
     */
    constructor(@Inject(MAT_DIALOG_DATA) public data: TransactionRule,
                private matDialogRef: MatDialogRef<DuplicateRuleDialogComponent>,
                private transactionsRulesService: TransactionsRulesService,
                private snackbar: MatSnackBar,) {
        this.rule = data;
    }

    ngOnInit(): void {

    }

    duplicate() {
        this.duplicating = true;

        const newRule = cloneDeep(this.rule);
        newRule.id = this.transactionsRulesService.createID();

        this.transactionsRulesService.doc(newRule.id).set(newRule)
            .then(() => {
                this.snackbar.open(
                    'Regel erfolgreich dupliziert. Vergessen Sie nicht, die Ziel‑Zuordnung anzupassen.',
                    'OK',
                    {duration: 4000, panelClass: ['snackbar-success']}
                )
                this.matDialogRef.close(newRule);
            })
            .catch((err) => {
                console.error('Error:', err);
                this.snackbar.open(
                    'Fehler beim Duplizieren der Regel. Bitte erneut versuchen.',
                    'Erneut',
                    {duration: 6000, panelClass: ['snackbar-error']}
                )
            })
            .finally(() => this.duplicating = false);
    }
}
